import styled from 'styled-components'

export const CloseButton = styled.button`
  display: flex;
  padding: var(--space-150);
  justify-content: center;
  align-items: center;
  gap: var(--space-150);
  margin-right: var(--space-n100);

  border-radius: var(--radius-brand);

  &:hover {
    background: var(--bg-transparent);
  }
`
